import React from "react";
import { Card, CardContent, makeStyles, Typography } from "@material-ui/core";

const useStyles = makeStyles({
  root: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    textAlign: "right",
  },
});

export default function CardEmpty({ text }) {
  const classes = useStyles();

  return (
    <Card className={`${classes.root} `} variant="outlined">
      <CardContent>
        <Typography variant="inherit" component="h5">
          {text ? text : "داده ای برای نمایش وجود ندارد."}
        </Typography>
      </CardContent>
    </Card>
  );
}
